import React from "react";

import { Stack } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yourWishesLinks } from "../../constants/constants";
import { getKeyFromText } from "../../utils/Utilities";

import "../../common/styles/common.scss";

const SideBar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <>
      <Stack className="side-bar" sx={{ width: "100%" }}>
        {yourWishesLinks.map((item) => (
          <Link
            key={item.id}
            to={item.to}
            className={`side-link${
              location.pathname === item.route ? " active" : ""
            }`}
          >
            {t(getKeyFromText(item.name))}
          </Link>
        ))}
      </Stack>
    </>
  );
};

export default SideBar;
